const $ = window.$;
import {get} from './ajax';
import {destroyChart, renderChart} from "./chart";

$(document).on('change', '.js-filter-select select', function () {
  const data = {};
  const dependentFilter = $(`[data-depends-on="${$(this).attr('name')}"]`);
  const updateFilter = $(this).parents('.js-filter-select').attr('data-update');

  if (updateFilter) {
    $(`[name="${updateFilter}"]`).val('');
  }

  if (dependentFilter && $(this).val() === dependentFilter.data('depends-value')) {
    dependentFilter.show();
  } else {
    dependentFilter.hide();
    dependentFilter.find('[name]').val('');
  }

  $("[class*='js-filter']").find('[name]').each(function () {
    data[$(this).attr('name')] = $(this).val();
  });

  function success(data) {
    if (updateFilter) {
      const newData = $(data).find(`[name="${updateFilter}"]`).html();
      $('[name="' + updateFilter + '"]').html(newData);
    }
    if ($('#charts').length) {
      const chartId = $('#charts').find('canvas').attr('id');
      destroyChart(chartId);
      renderChart(chartId);
    }
    $('.dd').replaceWith($(data).find('.dd'));
    if ($('.js-paginate')) {
      $('.js-paginate').replaceWith($(data).find('.js-paginate'));
    }
  }

  get(window.location.href, data, success);
});
